/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { Registration } from './components/Registration'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { SetPassword } from './components/SetPassword'
import { SelectPassword } from './components/SelectPassword'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom auth-bg position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/iToplight_logo.png')}
            className='h-100px img-fluid'
          />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        {/* <div className='bottom-logo'> */}
        <div>
          <img alt='PointGuard' className='img-fluid' src={toAbsoluteUrl('/media/logos/pointguard.png')} />
        </div>
        {/* </div> */}
        {/* <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
        </div> */}
      </div>
      {/* end::Footer */}
    </div>
  )
}

const searchParams = new URLSearchParams(window.location.search)

const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE;
const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      {(maintenanceMode != 'true' || (maintenanceMode == 'true' && searchParams.get('test') == 'PG')) ? (<>

        <Route path='login' element={<Login />} />
        <Route path='registration' element={<Registration />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='select-password' element={<SelectPassword />} />
        <Route path='set-password' element={<SetPassword />} />

        {/* <Route index element={<Login />} /> */}

        <Route index element={<Navigate to='/auth/login' replace />} />
      </>) :
        (<>
          <Route path='*' element={<Navigate to='/maintenance' />} />
        </>)}
    </Route>
  </Routes>
)

export { AuthPage }